import React from 'react';
import { QuotaItemConfig, getQuotaValues, UsageType } from '../../utils/quotaConfig';
import { UserQuota } from '../../types';

interface QuotaItemProps {
  config: QuotaItemConfig;
  quota: UserQuota;
  variant?: 'compact' | 'detailed';
  getUsagePercentage: (usageType: UsageType) => number;
}

const QuotaItem: React.FC<QuotaItemProps> = ({ 
  config, 
  quota, 
  variant = 'detailed', 
  getUsagePercentage 
}) => {
  const { used, max, unlimited } = getQuotaValues(quota, config.key);
  const percentage = unlimited ? 0 : getUsagePercentage(config.key);
  
  const getProgressColor = (percentage: number, unlimited: boolean) => {
    if (unlimited) return 'var(--quota-unlimited-color)';
    if (percentage >= 90) return 'var(--quota-danger-color)';
    if (percentage >= 75) return 'var(--quota-warning-color)';
    return 'var(--quota-safe-color)';
  };

  const color = getProgressColor(percentage, unlimited);

  if (variant === 'compact') {
    return (
      <div className="quota-item-compact" title={config.description}>
        <div className="quota-icon-compact" style={{ color }}>
          {config.icon}
        </div>
        <div className="quota-count-compact">
          {unlimited ? (
            <span className="quota-unlimited">∞</span>
          ) : (
            `${used}/${max}`
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="quota-item" title={config.description}>
      <div className="quota-header">
        <span className="quota-icon">{config.icon}</span>
        <span className="quota-label">{config.label}</span>
        <span className="quota-count">
          {unlimited ? (
            <span className="quota-unlimited">∞</span>
          ) : (
            `${used}/${max}`
          )}
        </span>
      </div>
      
      {!unlimited && (
        <div className="quota-progress-container">
          <div 
            className="quota-progress-bar"
            style={{ 
              width: `${percentage}%`,
              backgroundColor: color
            }}
          />
        </div>
      )}
    </div>
  );
};

export default QuotaItem;
